<template>
	<div class="questionTask">
		<van-nav-bar
			fixed
			placeholder
			safe-area-inset-top
			title="我的任务"
			left-text=""
			right-text=""
			@click-left="handleClickLeft"
			@click-right="handleClickRight"
		/>
		<div class="questionTask_tabs">
			<div
				:class="
					item.value === checkedTab
						? 'questionTask_tabs_item active'
						: 'questionTask_tabs_item'
				"
				v-for="(item, index) in tabList"
				:key="index"
				@click="() => handleSlectTab(item.value)"
			>
				{{ item.name }}
			</div>
		</div>
		<div class="questionTask_list">
			<van-list
				v-model="listLoading"
				:finished="pages.page >= pages.totalPages"
				@load="fetchList"
				finished-text="没有更多了"
			>
				<div
					class="questionTask_item"
					v-for="(item, index) in list"
					:key="index"
					@click="() => handleToRecord(item.id)"
				>
					<div class="questionTask_item_main">
						<div class="questionTask_item_main_info">
							<div class="questionTask_item_main_info_title">
								{{ item.title }}
							</div>
							<div class="questionTask_item_main_info_num">
								{{ item.description }}
							</div>
							<div class="questionTask_item_main_info_status">
								{{ computedTaskStatusName(item.status) }}
							</div>
						</div>
						<div class="questionTask_item_main_info_btn">
							详情
						</div>
					</div>
				</div>
			</van-list>
		</div>
		<tabBar />
	</div>
</template>
<script>
import { taskStatusName } from "@/common/map";
import { NavBar, List } from "vant";
import tabBar from "@/app/components/tabBar.vue";
export default {
	components: {
		[NavBar.name]: NavBar,
		[List.name]: List,
		tabBar
	},
	computed: {
		computedTaskStatusName() {
			return function(value) {
				return taskStatusName[value];
			};
		}
	},
	data() {
		return {
			tabList: [
				{ name: "全部任务", value: -1 },
				{ name: "未提交", value: 0 },
				{ name: "待审阅", value: 1 },
				{ name: "导师已阅读", value: 2 },
				{ name: "已过期", value: 3 }
			],
			checkedTab: -1,
			taskList: [],
			// 列表
			list: [],
			listLoading: true,
			pages: {
				page: 1,
				size: 10,
				totalPages: 2
			}
		};
	},
	mounted() {
		this.fetchList();
	},
	methods: {
		handleClickLeft() {},
		handleClickRight() {},
		initFetchList() {
			this.pages = { page: 1, totalPages: 2 };
			this.fetchList();
		},
		async fetchList() {
			let { page, totalPages } = this.pages;
			if (page >= totalPages) {
				return;
			}
			this.listLoading = true;
			let { content: list, ...pages } = await this.h5Ajax(
				"get",
				"$/distribute/distributeListPage",
				{
					status: this.checkedTab,
					page: this.pages.page,
					size: 10
				},
				true
			);
			h5CloseLoad();
			this.listLoading = false;
			this.list = page === 1 ? list : [...this.list, ...list];
			this.pages = { ...pages, page: page + 1 };
		},
		handleToRecord(id) {
			this.$router.push({ path: "/question/task/record", query: { id } });
		},
		handleSlectTab(value) {
			this.checkedTab = value;
			this.initFetchList();
		}
	}
};
</script>

<style>
@import "./index.css";
</style>



// WEBPACK FOOTER //
// src/app/pages/question/task/index.vue